import { render, staticRenderFns } from "./PageTwo.vue?vue&type=template&id=3c5cddc8&scoped=true&"
import script from "./PageTwo.vue?vue&type=script&lang=ts&"
export * from "./PageTwo.vue?vue&type=script&lang=ts&"
import style0 from "./PageTwo.vue?vue&type=style&index=0&id=3c5cddc8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5cddc8",
  null
  
)

export default component.exports